import angular from 'angular';
import ProfileAvatarCircleBridge from './ProfileAvatarCircleBridge';

angular
  .module('flowingly.directives')
  .component('profileAvatarCircle', ProfileAvatarCircleBridge);
